module.exports = __webpack_public_path__ + "static/hero-sala-tecnica-1800-ff6f39edd5edc69fa1dd3ca0d90f9325.jpg";